import React, {useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import {useNavigate, useSearchParams} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import {ProfileHeader} from '../ProfileHeader'
import MasterServices from '../../../../services/master'
import CompanyServices from '../../../../services/company'
import './Overview.css'
import CompanyJobListCard from './CompanyJobListCard'
import Contains from 'utils/helpers/Contains'

interface CompanyJob {
  companyId?: string
}

export const CompanyJobList: React.FC<CompanyJob> = ({companyId}) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [data] = useServices(
    searchParams.get('company') ? CompanyServices.showCompany : MasterServices.getCompanyProfile,
    searchParams.get('company')
  )
  const [company, setCompany] = useState<any>({})

  useEffect(() => {
    if (data) {
      setCompany(data?.data)
    }
  }, [data])
  return (
    <div className=''>
      {!Contains('company Company', [localStorage.getItem('role')]) && (
        <Button onClick={() => navigate(-1)} className='btn-sm mb-8' style={{padding: '4px'}}>
          <i className='bi bi-arrow-left fs-1'></i>
        </Button>
      )}
      <ProfileHeader />
      <h4 className='mt-8'>Pekerjaan di {company?.companies_name}</h4>
      <br />

      <CompanyJobListCard company={company}/> 
    </div>
  )
}
